// Route Path Constants
// All route paths are centralized here to ensure consistency and easy maintenance

export const ROUTE_PATHS = {
  // Public Routes
  LOGIN: '/login',
  REGISTRATION: '/registration',
  FORGOT_PASSWORD: '/forgot-password',
  
  // Common Routes
  SHAREABLE_MEDIA_KIT: 'shareable-media-kit/:id',
  PRIVACY_POLICY: '/legal/privacy-policy',
  TERMS_CONDITIONS: '/legal/creator/terms-conditions',
  KIT_VERIFIED: 'shareable-media-kit/kit-verified',
  MAIL_VERIFY: '/mail-verify',
  COLLAB_RATING: 'collabrationRating',
  LOGOUT: 'logout',
  EMAIL_VERIFICATION: '/email-verification',
  
  // Creator Private Routes
  MEDIA_KIT: '/media-kit/:id',
  MEDIA_KIT_DESKTOP_PREVIEW: '/media-kit/desktop-preview',
  SHAREABLE_LINK: '/dashboard/shareable-link',
  AUTHENTICATE_SOCIAL: '/dashboard/authenticate-social',
  BRANDS_REVIEWS: '/dashboard/brands-reviews',
  KIT_MANAGEMENT: '/dashboard/kit-management',
  GIFTED: '/dashboard/gifted',
  PAID: '/dashboard/paid',
  PROFILE_ACCOUNT: '/dashboard/profile-account',
  UPGRADE_MEDIA_KIT: '/dashboard/upgrade-media-kit',
  UPGRADE_OFFER: '/dashboard/upgrade-offer',
  MANAGE_SUBSCRIPTION: '/dashboard/manage-subscription',
  TIKTOK_AUTH: '/media-kit/tiktok-authentication',
  
  // Brand Routes
  BRANDS: '/brands',

  // Admin Routes
  ADMIN_ROOT: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_DETAIL: '/admin/users/:id',
};

// Route Module Names Constants
export const ROUTE_NAMES = {
  MEDIA_KIT: 'media-kit',
  MEDIA_KIT_DESKTOP_PREVIEW: 'media-kit-desktop-preview',
  SHAREABLE_LINK: 'shareable-link',
  AUTHENTICATE_SOCIAL: 'authenticate-social',
  BRANDS_REVIEWS: 'brands-reviews',
  KIT_MANAGEMENT: 'kit-management',
  GIFTED: 'gifted',
  PAID: 'paid',
  PROFILE_ACCOUNT: 'profile-account',
  UPGRADE_MEDIA_KIT: 'upgrade-media-kit',
  UPGRADE_OFFER: 'upgrade-offer',
  MANAGE_SUBSCRIPTION: 'manage-subscription',
  TIKTOK_AUTH: 'tiktok-authentication',
  EDIT_KIT: 'edit-kit',
  COLLAB_CENTER: 'collab-center',
  USER_PROFILE: 'user-profile',

  // Admin module names
  ADMIN_NAV: 'admin-nav',
  ADMIN_DASHBOARD: 'admin-dashboard',
  ADMIN_USERS: 'admin-users',
  ADMIN_USER_DETAIL: 'admin-user-detail',
};

